var Panoramas = $.extend(false, BaseModule ,{
    api_route : 'panoramas',

    data : {
        module      : 'panoramas',
        page        : 1,
        limit       : 20,
        order_by    : 'id:desc'
    },
    init:function(){}
});

$(document).ready(function(){
    "use strict";
    Panoramas.init();
});
